<script>
export default {
    props: {
        label: {
            required: false,
            default: null,
        },
        disabled: {
            required: false,
            default: false,
        },
        outlined: {
            required: false,
            default: false,
        },
        color: {
            required: false,
            default: '',
        },
        icon: {
            required: false,
            default: false,
        },
        block: {
            required: false,
            default: false,
        },
        text: {
            required: false,
            default: false,
        },
        small: {
            required: false,
            default: false,
        },
        large: {
            required: false,
            default: false,
        },
        depressed: {
            required: false,
            default: false,
        },
    },
}
</script>
